import React from 'react';

import { Route, Routes } from 'react-router-dom';

import { WorkflowCampaignDetails } from './details';
import { WorkflowList } from './list';

function Workflows() {
  return (
    <Routes>
      <Route element={<WorkflowCampaignDetails />} path='/overview/:marketingCampaignId/*' />
      <Route element={<WorkflowList />} path='/*' />
    </Routes>
  );
}

export default Workflows;
